import type { GlobalSearchResultItem } from 'models';
import { Avatar, Text } from 'ui';
import { images } from 'common/utils';
import { SearchItemRow } from '../search-item-row';

type P = {
  itemActionProps?: Record<string, unknown>;
  itemProps: GlobalSearchResultItem;
};

const GivingItem = ({ itemActionProps, itemProps }: P) => (
  <SearchItemRow
    icon={<Avatar alt={itemProps.name} photo={itemProps.coverPhoto ?? images.default.givingCoverPhoto} />}
    itemActionProps={itemActionProps}
  >
    <Text size="medium" weight="medium">
      {itemProps.name}
    </Text>
  </SearchItemRow>
);

export default GivingItem;
